module.exports = __webpack_public_path__ + "5d4aeb4e5f5ef754e307d7ffaef688bd.woff2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/typeface-roboto/files/roboto-latin-400.woff2
// module id = 663
// module chunks = 0